import api from "./api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getAllCategories = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllCategories", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createCategory = async (categoryData) => {
  try {
    const config = await getAuthConfig();
    const response = await api.post("/createCategory", categoryData, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCategory = async (categoryId, updateData) => {
  try {
    const config = await getAuthConfig();
    const response = await api.put(
      `/updateCategory/${categoryId}`,
      updateData,
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const config = await getAuthConfig();
    const response = await api.delete(`/deleteCategory/${categoryId}`, config);
    return response;
  } catch (error) {
    throw error;
  }
};
